// AICODE-NOTE: статический снэпшот из внешней Google-таблицы заказчика (соцсети NL,
// 2025-2026), импортирован один раз 2026-11-05. Это не доменная сущность приложения:
// данные не создаются и не меняются пользователем, поэтому они не ложатся на связку
// route -> service -> repository -> SQLite из AGENTS.md (там для мутируемых сущностей,
// а не для разового отчёта по внешнему экспорту). Обновить снэпшот — перегенерировать
// этот файл из таблицы, схема парсинга в истории чата/PR.

export const MONTHS_2026 = ['янв', 'фев', 'март', 'апр', 'май', 'июнь', 'июль', 'авг', 'сент'] as const;
export type Month2026 = (typeof MONTHS_2026)[number];

export interface MonthlyPoint {
  month: Month2026;
  posts: number | null;
  subs: number | null;
  reach: number | null;
  vr: number | null;
  err: number | null;
}

export interface Channel2026 {
  name: string;
  isNew: boolean;
  monthly: MonthlyPoint[];
}

export const channels2026: Channel2026[] = [
  { name: "ВК Бренд", isNew: false, monthly: [
    { month: "янв", posts: 60, subs: 278069, reach: 1007100, vr: 6, err: 24.6 },
    { month: "фев", posts: 87, subs: 280487, reach: 701742, vr: 2.9, err: 24.4 },
    { month: "март", posts: 84, subs: 284204, reach: 987672, vr: 4.1, err: 35.1 },
    { month: "апр", posts: 93, subs: 287464, reach: 848067, vr: 3.2, err: 205.1 },
    { month: "май", posts: 89, subs: 290982, reach: 1402818, vr: 5.4, err: 142.2 },
    { month: "июнь", posts: 95, subs: 294196, reach: 1404290, vr: 5, err: 241.3 },
    { month: "июль", posts: 72, subs: 296894, reach: 2489040, vr: 11.6, err: 80.5 },
    { month: "авг", posts: 41, subs: 299223, reach: 1352836, vr: 11, err: 52.3 },
    { month: "сент", posts: 38, subs: 302783, reach: 836684, vr: 7.3, err: 84.3 },
  ] },
  { name: "MAX Бренд", isNew: true, monthly: [
    { month: "янв", posts: 18, subs: null, reach: 374634, vr: null, err: 0 },
    { month: "фев", posts: 89, subs: 9216, reach: 4944395, vr: 602.8, err: 0.1 },
    { month: "март", posts: 99, subs: 16197, reach: 9574884, vr: 597.1, err: 0.1 },
    { month: "апр", posts: 99, subs: 19669, reach: 9426384, vr: 484.1, err: 16 },
    { month: "май", posts: 108, subs: 21027, reach: 5132484, vr: 226, err: 27.3 },
    { month: "июнь", posts: 116, subs: 23286, reach: 2954404, vr: 109.4, err: 63.8 },
    { month: "июль", posts: 78, subs: 24670, reach: 834990, vr: 43.4, err: 91.5 },
    { month: "авг", posts: 43, subs: 25565, reach: 542058, vr: 49.3, err: 51 },
    { month: "сент", posts: 37, subs: 26521, reach: 505198, vr: 51.5, err: 0.9 },
  ] },
  { name: "TG NL Все о бизнесе", isNew: true, monthly: [
    { month: "янв", posts: 17, subs: 2870, reach: 59942, vr: 122.9, err: 2.4 },
    { month: "фев", posts: 15, subs: 2911, reach: 49095, vr: 112.4, err: 2.8 },
    { month: "март", posts: 19, subs: 3011, reach: 41477, vr: 72.5, err: 2.7 },
    { month: "апр", posts: 16, subs: 2960, reach: 28816, vr: 60.8, err: 2.9 },
    { month: "май", posts: 13, subs: 2923, reach: 17732, vr: 46.7, err: 2.2 },
    { month: "июнь", posts: 18, subs: 2899, reach: 22824, vr: 43.7, err: 2.8 },
    { month: "июль", posts: 19, subs: 2889, reach: 25707, vr: 46.8, err: 1.9 },
    { month: "авг", posts: 21, subs: 5272, reach: 37779, vr: 34.1, err: 5.1 },
    { month: "сент", posts: 67, subs: 7719, reach: 148070, vr: 28.6, err: 3.8 },
  ] },
  { name: "MAX Продукт", isNew: true, monthly: [
    { month: "янв", posts: null, subs: null, reach: null, vr: null, err: null },
    { month: "фев", posts: null, subs: null, reach: null, vr: null, err: null },
    { month: "март", posts: null, subs: null, reach: null, vr: null, err: null },
    { month: "апр", posts: 24, subs: null, reach: null, vr: null, err: null },
    { month: "май", posts: 50, subs: 14093, reach: null, vr: null, err: null },
    { month: "июнь", posts: 56, subs: 16958, reach: null, vr: null, err: null },
    { month: "июль", posts: 68, subs: 20605, reach: null, vr: null, err: null },
    { month: "авг", posts: 66, subs: 23750, reach: null, vr: null, err: null },
    { month: "сент", posts: 62, subs: 26389, reach: null, vr: null, err: null },
  ] },
  { name: "ВК Продукт", isNew: true, monthly: [
    { month: "янв", posts: 2, subs: 59676, reach: null, vr: null, err: null },
    { month: "фев", posts: 11, subs: 60161, reach: null, vr: null, err: null },
    { month: "март", posts: 15, subs: 61045, reach: null, vr: null, err: null },
    { month: "апр", posts: 12, subs: 61045, reach: 11844, vr: null, err: null },
    { month: "май", posts: 25, subs: 61045, reach: 87550, vr: null, err: null },
    { month: "июнь", posts: 53, subs: 61045, reach: 593812, vr: null, err: null },
    { month: "июль", posts: 56, subs: 63405, reach: 679280, vr: null, err: null },
    { month: "авг", posts: 46, subs: 66084, reach: 1058874, vr: null, err: null },
    { month: "сент", posts: 42, subs: 67878, reach: 605724, vr: null, err: null },
  ] },
  { name: "YT int", isNew: false, monthly: [
    { month: "янв", posts: null, subs: null, reach: null, vr: null, err: null },
    { month: "фев", posts: null, subs: null, reach: null, vr: null, err: null },
    { month: "март", posts: null, subs: null, reach: null, vr: null, err: null },
    { month: "апр", posts: null, subs: 97141, reach: null, vr: 0, err: null },
    { month: "май", posts: 20, subs: 97211, reach: 11720, vr: 0.6, err: 0 },
    { month: "июнь", posts: null, subs: null, reach: null, vr: null, err: null },
    { month: "июль", posts: null, subs: null, reach: null, vr: null, err: null },
    { month: "авг", posts: null, subs: null, reach: null, vr: null, err: null },
    { month: "сент", posts: null, subs: null, reach: null, vr: null, err: null },
  ] },
  { name: "TG NL news", isNew: false, monthly: [
    { month: "янв", posts: 81, subs: 92370, reach: 3090474, vr: 41.3, err: 5.2 },
    { month: "фев", posts: 113, subs: 92540, reach: 2840368, vr: 27.2, err: 3.3 },
    { month: "март", posts: 121, subs: 91335, reach: 2644576, vr: 23.9, err: 4.6 },
    { month: "апр", posts: 119, subs: 88706, reach: 1466556, vr: 13.9, err: 270.5 },
    { month: "май", posts: 111, subs: 88071, reach: 975468, vr: 10, err: 270.5 },
    { month: "июнь", posts: 126, subs: 87562, reach: 1107540, vr: 10, err: 308 },
    { month: "июль", posts: 84, subs: 87195, reach: 559776, vr: 7.6, err: 192.8 },
    { month: "авг", posts: 65, subs: 86646, reach: 444665, vr: 7.9, err: 89.6 },
    { month: "сент", posts: 50, subs: 86030, reach: 391100, vr: 9.1, err: 57.8 },
  ] },
  { name: "Instagram", isNew: false, monthly: [
    { month: "янв", posts: 23, subs: 366024, reach: 846722, vr: 10.1, err: 12.6 },
    { month: "фев", posts: 43, subs: 365870, reach: 931079, vr: 5.9, err: 19.5 },
    { month: "март", posts: 31, subs: 365801, reach: 973865, vr: 8.6, err: 4.6 },
    { month: "апр", posts: 417, subs: 365839, reach: 1444071, vr: 0.9, err: 654.3 },
    { month: "май", posts: 371, subs: 354934, reach: 1157891, vr: 0.9, err: 573.1 },
    { month: "июнь", posts: 311, subs: 355853, reach: 2080279, vr: 1.9, err: 628.1 },
    { month: "июль", posts: 279, subs: 356187, reach: 1467540, vr: 1.5, err: 343.3 },
    { month: "авг", posts: 21, subs: 356400, reach: 728406, vr: 9.7, err: 44.4 },
    { month: "сент", posts: 21, subs: 356735, reach: 945105, vr: 12.6, err: 13.5 },
  ] },
  { name: "Одноклассники", isNew: false, monthly: [
    { month: "янв", posts: 65, subs: 4125, reach: 43290, vr: 16.1, err: 10.5 },
    { month: "фев", posts: 74, subs: 4156, reach: 36482, vr: 11.9, err: 8.5 },
    { month: "март", posts: 74, subs: 4581, reach: 67044, vr: 19.8, err: 16.4 },
    { month: "апр", posts: 82, subs: 4659, reach: 31406, vr: 8.2, err: 139.2 },
    { month: "май", posts: 73, subs: 4696, reach: 18469, vr: 5.4, err: 153.4 },
    { month: "июнь", posts: 74, subs: 4735, reach: 24790, vr: 7.1, err: 135.8 },
    { month: "июль", posts: 39, subs: 4759, reach: 8502, vr: 4.6, err: 90.4 },
    { month: "авг", posts: 21, subs: 4776, reach: 7749, vr: 7.7, err: 34.7 },
    { month: "сент", posts: 27, subs: 4810, reach: 9180, vr: 7.1, err: 3.5 },
  ] },
  { name: "TikTok", isNew: true, monthly: [
    { month: "янв", posts: 8, subs: 1119, reach: 256000, vr: 2859.7, err: 2.7 },
    { month: "фев", posts: 11, subs: 1155, reach: 308000, vr: 2424.2, err: 2.8 },
    { month: "март", posts: 15, subs: 1409, reach: 285000, vr: 1348.5, err: 4.5 },
    { month: "апр", posts: 11, subs: 1668, reach: 209000, vr: 1139.1, err: 3.6 },
    { month: "май", posts: 14, subs: 1752, reach: 294000, vr: 1198.6, err: 4 },
    { month: "июнь", posts: 15, subs: 1843, reach: 300000, vr: 1085.2, err: 2.9 },
    { month: "июль", posts: 7, subs: 1929, reach: 111300, vr: 824.3, err: 2.3 },
    { month: "авг", posts: 8, subs: 2036, reach: 132800, vr: 815.3, err: 3 },
    { month: "сент", posts: null, subs: null, reach: null, vr: null, err: null },
  ] },
  { name: "Pinterest", isNew: false, monthly: [
    { month: "янв", posts: 21, subs: 4790, reach: 3933300, vr: 3910.2, err: 0 },
    { month: "фев", posts: 30, subs: 4907, reach: 6171000, vr: 4192, err: 0 },
    { month: "март", posts: 21, subs: 5599, reach: 4538100, vr: 3859.6, err: 0 },
    { month: "апр", posts: 20, subs: 5700, reach: 4510000, vr: 3956.1, err: 0 },
    { month: "май", posts: 20, subs: 5717, reach: 3884000, vr: 3396.9, err: 0 },
    { month: "июнь", posts: 20, subs: 5801, reach: 4700000, vr: 4051, err: 0 },
    { month: "июль", posts: 26, subs: 5739, reach: 6916000, vr: 4635, err: 0 },
    { month: "авг", posts: 10, subs: 5771, reach: 2658000, vr: 4605.8, err: 0 },
    { month: "сент", posts: null, subs: null, reach: null, vr: null, err: null },
  ] },
];

export interface Channel2025Yearly {
  name: string;
  subsMonthly: (number | null)[];
  reachMonthly: (number | null)[];
  engagementMonthly: (number | null)[];
  reachTotal: number | null;
  subsEnd: number | null;
}

export const channels2025: Channel2025Yearly[] = [
  { name: "ВК Бренд",
    subsMonthly: [273078, 277010, 280941, 284010, 286754, 290610, 293546, 296292, 298886, 301997, 307788, 312595],
    reachMonthly: [891712, 913549, 784234, 1005100, 703511, 1211663, 806404, 579841, 773543, 620206, 600921, 1066508],
    engagementMonthly: [27148, 28035, 23913, 34814, 21662, 34790, 28656, 12930, 26501, 20955, 37648, 22812],
    reachTotal: 9957192, subsEnd: 312595 },
  { name: "TG NL news",
    subsMonthly: [73959, 76261, 78605, 80425, 82445, 84998, 87075, 88671, 89803, 91030, 92198, 91274],
    reachMonthly: [1741692, 2622754, 2259182, 2517321, 1918132, 2829190, 2502139, 2097095, 2410899, 3490966, 2734652, 2973979],
    engagementMonthly: [44874, 51501, 51786, 49664, 42960, 61813, 51134, 43356, 63159, 83301, 61617, 78755],
    reachTotal: 30098001, subsEnd: 91274 },
  { name: "Instagram",
    subsMonthly: [364239, 364896, 365151, 365901, 366200, 366887, 367154, 367167, 366704, 366506, 366496, 366294],
    reachMonthly: [371044, 369585, 254765, 455222, 310289, 479267, 350579, 234675, 113945, 324332, 299657, 329813],
    engagementMonthly: [24067, 24119, 18647, 41293, 24460, 47376, 32301, 19314, 5632, 28583, 25083, 27658],
    reachTotal: 3893173, subsEnd: 366294 },
  { name: "Одноклассники",
    subsMonthly: [3536, 3609, 3672, 3702, 3741, 3776, 3836, 3872, 3914, 3973, 4027, 4072],
    reachMonthly: [24096, 23578, 13715, 17668, 14231, 19507, 18275, 13601, 16883, 26885, 30215, 33979],
    engagementMonthly: [571, 768, 485, 565, 505, 880, 647, 404, 553, 802, 757, 930],
    reachTotal: 252633, subsEnd: 4072 },
  { name: "YT int",
    subsMonthly: [96655, 96749, 96829, 96953, 97016, 97036, 97062, 97113, 97155, 97190, 97191, 97194],
    reachMonthly: [13370, 13105, 13904, 19732, 11988, 13557, null, 22592, 7816, 24339, 21836, 14180],
    engagementMonthly: [null, null, null, null, null, null, null, null, null, null, null, null],
    reachTotal: 176419, subsEnd: 97194 },
  { name: "Pinterest",
    subsMonthly: [null, null, null, 4100, null, 4600, 4700, 4700, null, null, null, null],
    reachMonthly: [null, null, null, null, null, 18000, 21140, 59520, null, null, null, null],
    engagementMonthly: [null, null, null, null, null, 2390, 3520, 5570, null, null, null, null],
    reachTotal: 98660, subsEnd: null },
];

export interface YearlyChannelDetail {
  channel: string;
  reach: number | null;
  subs: number | null;
  er: number | null;
}

export const yearTotals = {
  y2025: { reach: 44476078, subs: 876129, er: 0.0572 },
  y2026: { reach: 82907989, subs: 983883, er: 0.0213 },
  yoyAbs: { reach: 38431911, subs: 107754 },
  yoyPct: { reach: 0.864, subs: 0.123, er: -0.0359 },
};

export const channelYearly2025: YearlyChannelDetail[] = [
  { channel: "ВК Бренд", reach: 9957192, subs: 312595, er: 0.0321 },
  { channel: "TG NL news", reach: 30098001, subs: 91274, er: 0.0227 },
  { channel: "Instagram", reach: 3893173, subs: 366294, er: 0.0818 },
  { channel: "Одноклассники", reach: 252633, subs: 4072, er: 0.0311 },
  { channel: "YT int", reach: 176419, subs: 97194, er: 0 },
  { channel: "Pinterest", reach: 98660, subs: 4700, er: 0.1184 },
];

export const channelYearly2026: YearlyChannelDetail[] = [
  { channel: "ВК Бренд", reach: 11030249, subs: 302783, er: 0.0187 },
  { channel: "MAX Бренд", reach: 34289431, subs: 26521, er: 0.0023 },
  { channel: "TG NL Все о бизнесе", reach: 431442, subs: 7719, er: 0.0321 },
  { channel: "YT int", reach: 55896, subs: 97211, er: null },
  { channel: "TG NL news", reach: 13520523, subs: 86030, er: 0.0357 },
  { channel: "Instagram", reach: 10574958, subs: 356735, er: 0.0182 },
  { channel: "Одноклассники", reach: 246912, subs: 4810, er: 0.0146 },
  { channel: "TikTok", reach: 171500, subs: 2036, er: 0.0318 },
  { channel: "ВК Продукт", reach: 3105082, subs: 67878, er: 0.0214 },
  { channel: "MAX Продукт", reach: 7686396, subs: 26389, er: 0.0068 },
  { channel: "Pinterest", reach: 1795600, subs: 5771, er: 0.0312 },
];

export interface TopPost {
  month: string;
  format: string;
  title: string;
  views: number | null;
  reactions: number | null;
  eng: number | null;
}

export const topPosts: TopPost[] = [
  { month: "авг", format: "Reels (Instagram)", title: "у нас скидки", views: 92665, reactions: 997, eng: 1186 },
  { month: "авг", format: "Reels (Instagram)", title: "День рождения у Дмитрия Хохлова", views: 54248, reactions: 2100, eng: 2606 },
  { month: "авг", format: "Reels (Instagram)", title: "у нас скидки", views: 46652, reactions: 522, eng: 616 },
  { month: "авг", format: "Reels (Instagram)", title: "Пептидный коллаген", views: 34772, reactions: 602, eng: 755 },
  { month: "авг", format: "ВК Клипы", title: "У нас скидки", views: 30794, reactions: 415, eng: 537 },
];

export const productFunnel = {
  maxProdukt: { visits: 23619, revenue: 907064.76, cpc: 38.404 },
  vkProdukt: { visits: 2096, revenue: 518295.06, cpc: 247.2782 },
};

export interface ChannelSubsStatus {
  channel: string;
  base: number | null;
  fact: number | null;
  deltaToBase: number | null;
  status: 'Рост' | 'Держится' | 'Падение';
}

export const channelSubsStatus: ChannelSubsStatus[] = [
  { channel: "ВК Бренд", base: 287470.8571, fact: 302783, deltaToBase: 0.0533, status: "Рост" },
  { channel: "MAX Бренд", base: 19010.8333, fact: 26521, deltaToBase: 0.395, status: "Рост" },
  { channel: "TG NL Все о бизнесе", base: 2923.2857, fact: 7719, deltaToBase: 1.6405, status: "Рост" },
  { channel: "YT int", base: 97193.5, fact: 97211, deltaToBase: 0.0002, status: "Держится" },
  { channel: "TG NL news", base: 89682.7143, fact: 86030, deltaToBase: -0.0407, status: "Держится" },
  { channel: "Instagram", base: 361501.1429, fact: 356735, deltaToBase: -0.0132, status: "Держится" },
  { channel: "Одноклассники", base: 4530.1429, fact: 4810, deltaToBase: 0.0618, status: "Рост" },
  { channel: "TikTok", base: 1553.5714, fact: 2036, deltaToBase: 0.3105, status: "Рост" },
  { channel: "ВК Продукт", base: 61060.2857, fact: 67878, deltaToBase: 0.1117, status: "Рост" },
  { channel: "MAX Продукт", base: 18851.5, fact: 26389, deltaToBase: 0.3998, status: "Рост" },
];

function sumPresent(values: (number | null)[]): number | null {
  const present = values.filter((v): v is number => v != null);
  return present.length ? present.reduce((a, b) => a + b, 0) : null;
}

export interface TotalMonthlyPoint {
  label: string;
  reach: number | null;
  subs: number | null;
}

const MONTHS_2025_FULL = ['янв', 'фев', 'март', 'апр', 'май', 'июнь', 'июль', 'авг', 'сент', 'окт', 'нояб', 'дек'];

export const totalMonthly2025: TotalMonthlyPoint[] = MONTHS_2025_FULL.map((m, i) => ({
  label: `${m} '25`,
  reach: sumPresent(channels2025.map((c) => c.reachMonthly[i])),
  subs: sumPresent(channels2025.map((c) => c.subsMonthly[i])),
}));

export const totalMonthly2026: TotalMonthlyPoint[] = MONTHS_2026.map((m, i) => ({
  label: `${m} '26`,
  reach: sumPresent(channels2026.map((c) => c.monthly[i].reach)),
  subs: sumPresent(channels2026.map((c) => c.monthly[i].subs)),
}));

export const totalMonthlyCombined: TotalMonthlyPoint[] = [...totalMonthly2025, ...totalMonthly2026];

